import { ReactComponent as PlusRoundIcon } from "images/plus-round.svg";
import { AddTemplatesFileModal } from "./AddTemplatesFileModal";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton, FileType } from "ui";

type Props = {
  type?: string;
  tooltip?: string;
  fn: ({ file, type }: { file: FileType; type?: string }) => Promise<any>;
  successMessage?: string;
  onSuccess?: () => Promise<void>;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
};

export const AddTemplatesFileBtn = observer(
  ({ type, tooltip, fn, successMessage, onSuccess, className, disabled, loading }: Props) => {
    const { actionModals } = useStores();

    const handleOpenModal = () => {
      actionModals.open(
        () => (
          <AddTemplatesFileModal
            type={type ?? ""}
            fn={({ file, type }) => fn({ file, type })}
            successMessage={successMessage}
            onSuccess={onSuccess}
          />
        ),
        {
          width: "600px",
          noValidation: true,
          isOverlayClose: false,
        }
      );
    };

    return (
      <CustomButton
        tooltip={tooltip}
        size="small"
        type="text"
        onClick={handleOpenModal}
        icon={<PlusRoundIcon />}
        className={className}
        disabled={disabled}
        loading={loading}
      />
    );
  }
);
